import React, { useEffect, useState } from 'react';
import FarmerDetails from '../../components/FarmerDetails/FarmerDetails';
import CurrentIssues from '../../components/FarmerDetails/CurrentIssues';
import PastIssues from '../../components/FarmerDetails/PastIssues';
import {Container, Row, Col, Card, Tabs, Tab, Badge} from 'react-bootstrap';
import { useParams, useLocation, Link } from "react-router-dom";
import colors from '../../config/colors';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import getFarmerDetails from '../../components/FarmerDetails/getFarmerDetails';

const ViewFarmer = (props) => {
    const { mobileNumber } = useParams();
    const location = useLocation();
    const [farmerInfo, setFarmerInfo] = useState(null);

    useEffect(() => {
        const loadFarmerData = async () => {
            const response = await getFarmerDetails(mobileNumber);
            if (response && response.status === 200) {
                setFarmerInfo(response.data);
            }
        };
        loadFarmerData();
    }, [mobileNumber]);

    return (
        <Container fluid style={{marginTop:'5rem', marginBottom: '1rem', paddingLeft: '1.2rem', paddingRight: '1.2rem'}}>
            {farmerInfo && (
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1rem" }}>
                    <div>
                        <div style={{ fontWeight: 800, fontSize: "1.1rem", color: "#1a3328" }}>{farmerInfo.fullName}</div>
                        <div style={{ fontSize: "0.8rem", color: "#5a6e61" }}>📍 {[farmerInfo.townVillage, farmerInfo.district, farmerInfo.state].filter(Boolean).join(", ")}</div>
                    </div>
                    <div style={{ display: "flex", gap: "0.5rem" }}>
                        <a href={`tel:${mobileNumber}`} style={{ textDecoration: "none" }}>
                            <button style={{ backgroundColor: "#b8860b", color: "#fff", border: "none", borderRadius: 8, padding: "0.45rem 1rem", fontWeight: 600, fontSize: "0.88rem", cursor: "pointer" }}>
                                📞 Call
                            </button>
                        </a>
                    </div>
                </div>
            )}
            <Row>
                <Col lg={6} className="mb-3">
                    <FarmerDetails mobileNumber={mobileNumber} />
                </Col>
                <Col lg={6}>
                    <Card style={{ borderRadius: 12, border: "1px solid #d8e4dc", boxShadow: "0 8px 20px rgba(0,0,0,0.06)" }}>
                        <Card.Body style={{ padding: "1rem" }}>
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <div style={{ fontWeight: 700, color: colors.green, fontSize: "1rem" }}>Issues</div>
                                <Link to={{ pathname: `/addIssue/${mobileNumber}`, state: {farmerID : location.state.farmerID}}} style={{textDecoration: 'none'}}>
                                    <div style={{ backgroundColor: colors.green, color: colors.white, padding: '0.45rem 0.75rem', borderRadius: 8, textAlign: 'center', fontWeight: 600, fontSize: "0.9rem" }}>
                                        <FontAwesomeIcon icon={faPlus} style={{ marginRight: "0.4rem" }} />
                                        Add New Issue
                                    </div>
                                </Link>
                            </div>
                            <Tabs defaultActiveKey="current" id="farmer-issue-tabs" className="mb-0">
                                <Tab eventKey="current" title="Current Issues">
                                    <CurrentIssues farmerID={location.state.farmerID} compact />
                                </Tab>
                                <Tab eventKey="past" title="Past Issues">
                                    <PastIssues farmerID={location.state.farmerID} compact />
                                </Tab>
                            </Tabs>
                        </Card.Body>
                    </Card>

                    <Card style={{ borderRadius: 12, border: "1px solid #d8e4dc", boxShadow: "0 8px 20px rgba(0,0,0,0.06)", marginTop: "1rem" }}>
                        <Card.Header style={{ backgroundColor: "#f1f7f3", color: colors.green, fontWeight: 700 }}>
                            Appointments
                        </Card.Header>
                        <Card.Body style={{ padding: "0.9rem 1rem" }}>
                            <Row style={{ marginBottom: "0.55rem" }}>
                                <Col xs={6} style={{ color: "#667b6f" }}>Appointment Status</Col>
                                <Col xs={6} className="text-right"><Badge style={{ backgroundColor: "#3b8f53", color: "#fff", fontSize: "0.78rem" }}>Scheduled</Badge></Col>
                            </Row>
                            <Row style={{ marginBottom: "0.55rem" }}>
                                <Col xs={6} style={{ color: "#667b6f" }}>Visit Status</Col>
                                <Col xs={6} className="text-right"><Badge style={{ backgroundColor: "#f0ad4e", color: "#fff", fontSize: "0.78rem" }}>Pending</Badge></Col>
                            </Row>
                            <Row style={{ marginBottom: "0.55rem" }}>
                                <Col xs={6} style={{ color: "#667b6f" }}>Visit Result</Col>
                                <Col xs={6} className="text-right"><Badge style={{ backgroundColor: "#dc3545", color: "#fff", fontSize: "0.78rem" }}>Not Converted</Badge></Col>
                            </Row>
                            <Row>
                                <Col xs={6} style={{ color: "#667b6f" }}>Field Staff</Col>
                                <Col xs={6} className="text-right" style={{ fontWeight: 600 }}>Manshya Team</Col>
                            </Row>
                        </Card.Body>
                    </Card>

                    <Row style={{ marginTop: "1rem" }}>
                        <Col md={6} className="mb-3 mb-md-0">
                            <Card style={{ borderRadius: 12, border: "1px solid #d8e4dc", boxShadow: "0 8px 18px rgba(0,0,0,0.05)", height: "100%" }}>
                                <Card.Header style={{ backgroundColor: "#f1f7f3", color: colors.green, fontWeight: 700 }}>
                                    Nearby Data
                                </Card.Header>
                                <Card.Body style={{ padding: "0.9rem 1rem" }}>
                                    <div style={{ marginBottom: "0.6rem" }}><span style={{ color: "#667b6f" }}>Village:</span> <b>{farmerInfo?.townVillage || "-"}</b></div>
                                    <div style={{ marginBottom: "0.6rem" }}><span style={{ color: "#667b6f" }}>District:</span> <b>{farmerInfo?.district || "-"}</b></div>
                                    <div><span style={{ color: "#667b6f" }}>State:</span> <b>{farmerInfo?.state || "-"}</b></div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6}>
                            <Card style={{ borderRadius: 12, border: "1px solid #d8e4dc", boxShadow: "0 8px 18px rgba(0,0,0,0.05)", height: "100%" }}>
                                <Card.Header style={{ backgroundColor: "#f1f7f3", color: colors.green, fontWeight: 700 }}>
                                    Nearby Shops
                                </Card.Header>
                                <Card.Body style={{ padding: "0.9rem 1rem" }}>
                                    <div style={{ marginBottom: "0.6rem" }}><span style={{ color: "#667b6f" }}>Input Dealers:</span> <b>3</b></div>
                                    <div style={{ marginBottom: "0.6rem" }}><span style={{ color: "#667b6f" }}>Manshya Retail Points:</span> <b>1</b></div>
                                    <div><span style={{ color: "#667b6f" }}>New Farmers Nearby:</span> <b>5</b></div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    )
}

export default ViewFarmer;
